import * as userActions from '../user/actions';
import * as lawsCategoriesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsCategoriesActions.SET_LAWS_CATEGORIES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsCategoriesActions.SET_LAWS_CATEGORIES_ERROR:
            return {
                ...initialState,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsCategoriesActions.SET_LAWS_ALL_CATEGORIES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsCategoriesActions.ABORT_LAWS_CATEGORIES_REQUEST:
            return initialState;

        case lawsCategoriesActions.CLEAN_LAWS_CATEGORIES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 16+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 20+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsCategories/reducer.js